import { render, staticRenderFns } from "./CommunityHealthInfoCreate.vue?vue&type=template&id=29235270"
import script from "./CommunityHealthInfoCreate.vue?vue&type=script&lang=js"
export * from "./CommunityHealthInfoCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityHealthInfoCreate.vue?vue&type=style&index=0&id=29235270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports